import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Input, Label, Icon, Form, Popup } from 'semantic-ui-react';

// Mirrors the hashtags-input field so the two sit together in a form.
const inputStyle = { marginBottom: 10 };
const tagStyle = { marginTop: 4, marginRight: 4, border: 'none', background: '#fde8e8', color: '#9f3a38' };
const iconStyle = { color: '#9f3a38' };
const headerStyle = { display: 'flex', alignItems: 'center', marginBottom: 4 };
const labelStyle = { fontSize: '0.92857143em', fontWeight: 700, color: 'rgba(0,0,0,.87)' };

export const toKeywords = csv => _.uniqBy(_.compact(_.map(_.split(csv, ','), _.trim)), _.toLower);

const HelpPopup = () => <Popup
  content="Posts, TikToks and stories whose caption or hashtags contain any of these keywords are left out of reports.
    You can enter multiple keywords separated by commas."
  trigger={<Icon name="help circle" className="circular" />}
/>;

export default class NegativeKeywordsInput extends Component {
  constructor(props) {
    super(props);
    this.state = { value: '', isDuplicate: false };
  }

  onInputChange = (e, { value }) => {
    this.setState({ value, isDuplicate: false });
  }

  onKeyPress = e => {
    if (e.key === 'Enter') this.onAdd(e);
  }

  // preventDefault stops the + button and Enter from submitting a surrounding form.
  onAdd = e => {
    if (e) e.preventDefault();
    const { keywords, isSaving, onChange } = this.props;
    const entered = toKeywords(this.state.value);
    if (isSaving || _.isEmpty(entered)) return;
    const current = toKeywords(keywords);
    const seen = _.map(current, _.toLower);
    const added = _.reject(entered, k => _.includes(seen, _.toLower(k)));
    if (_.isEmpty(added)) {
      this.setState({ isDuplicate: true });
      return;
    }
    this.setState({ value: '' });
    onChange(_.join([...current, ...added], ','));
  }

  onDelete = keyword => {
    const { keywords, isSaving, onChange } = this.props;
    if (isSaving) return;
    onChange(_.join(_.without(toKeywords(keywords), keyword), ','));
  }

  renderTag = keyword => (
    <Label key={keyword} size="large" style={tagStyle}>
      {keyword}
      <Icon name="close" link style={iconStyle} onClick={() => this.onDelete(keyword)} />
    </Label>
  );

  render() {
    const { keywords, isSaving, error, hideLabel } = this.props;
    const { value, isDuplicate } = this.state;
    const message = error || (isDuplicate ? 'That keyword has already been added.' : null);
    const actionProps = {
      icon: 'plus',
      onClick: this.onAdd,
      disabled: isSaving || _.isEmpty(toKeywords(value)),
      loading: isSaving,
    };

    return (
      <Form.Field>
        {
          !hideLabel &&
          <div style={headerStyle}>
            <label htmlFor="campaign-negative-keywords" style={labelStyle}>
              Negative keywords <HelpPopup />
            </label>
          </div>
        }
        {
          message ? (
            <Label basic color="red" pointing="below">
              {message}
            </Label>) : null
        }
        <Input
          fluid
          action={actionProps}
          onChange={this.onInputChange}
          onKeyPress={this.onKeyPress}
          placeholder="e.g. body lotion, gifted"
          value={value}
          style={inputStyle}
        />
        { _.map(toKeywords(keywords), this.renderTag) }
      </Form.Field>
    );
  }
}

NegativeKeywordsInput.propTypes = {
  keywords: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  error: PropTypes.string,
  hideLabel: PropTypes.bool,
};

NegativeKeywordsInput.defaultProps = {
  keywords: '',
  isSaving: false,
  error: null,
  hideLabel: false,
};



/** WEBPACK FOOTER **
 ** ./src/components/negative-keywords-input/index.js
 **/